module.exports = __webpack_public_path__ + "static/img/international.79576b05.svg";